module.exports = __webpack_public_path__ + "img/lm-home-services.1f485a9e.png";